
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/creator/[creatorId]",
      function () {
        return require("private-next-pages/creator/[creatorId]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/creator/[creatorId]"])
      });
    }
  